import React from 'react';
// @ts-ignore
import DHContainer from "@digital-hig/mui/Container";

interface ResponsiveContainerProps {
  children: React.ReactNode;
}

export const ResponsiveContainer: React.FC<ResponsiveContainerProps> = ({ children }) => {
  return (
    <DHContainer 
      maxWidth="lg" 
      sx={{ 
        py: 4, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        // Digital HIG responsive margins: 20px left/right on all screen sizes
        px: { xs: '20px', sm: '20px', md: '20px', lg: '20px', xl: '20px' },
        // Digital HIG responsive max width to prevent horizontal scroll
        maxWidth: { 
          xs: 'calc(100% - 40px)', 
          sm: 'calc(100% - 40px)', 
          md: 'calc(100% - 40px)', 
          lg: 'calc(1296px + 40px)', 
          xl: 'calc(1296px + 40px)' 
        },
        width: { 
          xs: 'calc(100% - 40px)', 
          sm: 'calc(100% - 40px)', 
          md: 'calc(100% - 40px)', 
          lg: 'calc(1296px + 40px)', 
          xl: 'calc(1296px + 40px)' 
        },
        margin: '0 auto',
        boxSizing: 'border-box',
        // Digital HIG breakpoint for 1320px
        '@media (min-width: 1320px)': {
          maxWidth: 'calc(1296px + 40px)',
          width: 'calc(100% - 40px)',
          paddingLeft: '20px',
          paddingRight: '20px',
          margin: '0 auto',
          boxSizing: 'border-box'
        },
        '@media (max-width: 1319px)': {
          maxWidth: 'calc(100% - 40px)',
          width: 'calc(100% - 40px)',
          paddingLeft: '20px',
          paddingRight: '20px',
          margin: '0 auto',
          boxSizing: 'border-box'
        }
      }}
    >
      {children}
    </DHContainer>
  );
};

